'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

exports.default = shallowEquals;
exports.shallowEqualsDebug = shallowEqualsDebug;
/**
 * Helper function to include or exclude keys before comparing
 */

function excludeIncludeKeys(objA, objB, excludeKeys, includeKeys) {
  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (excludeKeys) {
    keysA = keysA.filter(function (key) {
      return excludeKeys.indexOf(key) === -1;
    });
    keysB = keysB.filter(function (key) {
      return excludeKeys.indexOf(key) === -1;
    });
  } else if (includeKeys) {
    keysA = keysA.filter(function (key) {
      return includeKeys.indexOf(key) !== -1;
    });
    keysB = keysB.filter(function (key) {
      return includeKeys.indexOf(key) !== -1;
    });
  }

  return [keysA, keysB];
}
/**
 * Modified from React's PureRenderMixin - https://github.com/francoislaberge/pure-render-mixin/blob/master/src/shallow-equal.js
 * (MIT License Copyright (c) 2015 Francois Laberge)
 *
 * Performs equality by iterating through keys on an object and returning
 * false when any key has values which are not strictly equal between
 * objA and objB. Returns true when the values of all keys are strictly equal.
 *
 * @return {Boolean}
 */


function shallowEquals(objA, objB, excludeKeys, includeKeys) {
  if (objA === objB) {
    return true;
  }

  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
    return false;
  }

  var _excludeIncludeKeys = excludeIncludeKeys(objA, objB, excludeKeys, includeKeys),
      _excludeIncludeKeys2 = _slicedToArray(_excludeIncludeKeys, 2),
      keysA = _excludeIncludeKeys2[0],
      keysB = _excludeIncludeKeys2[1];

  if (keysA.length !== keysB.length) {
    return false;
  } // Test for A's keys different from B.


  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  for (var i = 0; i < keysA.length; i += 1) {
    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
      return false;
    }
  }

  return true;
}
/**
 * Logs and returns an array showing the places where shallow equals failed or the string "equal"
 */


function shallowEqualsDebug(objA, objB, excludeKeys, includeKeys) {
  var logPrefix = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'shallowEqualsDebug';
  var result = void 0;

  if (shallowEquals(objA, objB, excludeKeys, includeKeys)) {
    result = 'equal';
  } else {
    var _excludeIncludeKeys3 = excludeIncludeKeys(objA, objB, excludeKeys, includeKeys),
        _excludeIncludeKeys4 = _slicedToArray(_excludeIncludeKeys3, 2),
        keysA = _excludeIncludeKeys4[0],
        keysB = _excludeIncludeKeys4[1];

    result = keysA.concat(keysB.filter(function (key) {
      return objA[key] === undefined;
    })) // add in keys in B not in A
    .filter(function (key) {
      return objA[key] !== objB[key];
    }) // add in keys where they don't match
    .map(function (key) {
      return {
        key: key,
        a: objA[key],
        b: objB[key]
      };
    }).reduce(function (acc, elem) {
      acc.push(elem.key);
      acc.push(elem.a);
      acc.push(elem.b);
      return acc;
    }, []);
  } // eslint-disable-next-line no-console


  console.log(logPrefix + ':', result);
  return result;
}